exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-79ec5d78] textarea {\n  min-height: 107px !important;\n}", ""]);

// exports
